import React from 'react';
import './Technologies.css';

const logoFilenames = [
  'ansible.svg', 'apache.svg', 'aws.svg', 'bash.svg',
  'bootstrap.svg', 'docker.svg', 'gcp.svg', 'git.svg',
  'html5.svg', 'java.svg', 'javascript.svg', 'jira.svg', 'mongodb.svg',
  'mysql.svg', 'nginx.svg', 'nodejs.svg', 'postgresql.svg', 'postman.svg',
  'powershell.svg', 'python.svg', 'react.svg', 'terraform.svg', 'ubuntu.svg', 'yaml.svg'
];

const Technologies = () => {
  return (
    <section className="technologies-section">
      <h2 className="technologies-title">Technologies</h2>
      <div className="tech-grid">
        {logoFilenames.map((filename, index) => (
          <div className="tech-badge" key={index}>
            <img src={`/assets-technologies/${filename}`} alt={filename.split('.')[0]} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Technologies;
